module.exports = "/_next/static/images/iPhone-2b1e334a7ba55de01a0d275e2b98e8b0.png";